export default "__VITE_ASSET__DVDCUSmF__"